import format from "date-fns/format";
/**
 * Returns a function that formats a date in a specific format
 *
 * @param fmt - format to use (docs here https://date-fns.org/v1.30.1/docs/format)
 * @return formats a date
 */ export default function() {
    var fmt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "M/D/YY";
    return function(v) {
        return v ? format(v, fmt) : "-";
    };
};
